import React from 'react';
import classNames from 'classnames';
import styles from './SubHeaderPanel.module.scss';

interface SubHeaderPanelProps {
  className?: string;
  children: React.ReactNode;
}

interface StaticMenuComponents {
  Divider: typeof Divider;
}

export const SubHeaderPanel: React.FC<SubHeaderPanelProps> & StaticMenuComponents = ({ className, children }) => (
  <div className={classNames('flex flex-row', styles.root, className)}>{children}</div>
);

export const Divider = () => <div className={styles.divider} />;

SubHeaderPanel.Divider = Divider;
